import { render, staticRenderFns } from "./BmManualResultModal.vue?vue&type=template&id=f1b8f982&"
import script from "./BmManualResultModal.vue?vue&type=script&lang=js&"
export * from "./BmManualResultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports